function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdPlanPerkChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    style: {},
    fill: "#5dd39e",
    "data-original": "#06ccab",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m511.925 261.908-98.273-98.273L99.567 395.511 212.33 508.274A257.561 257.561 0 0 0 256 512c139.41 0 252.784-111.437 255.925-250.092z",
    style: {},
    fill: "#5ec597",
    "data-original": "#11a892",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.001 228.703c-57.693 0-104.463 37.341-104.463 83.404 0 21.824 10.504 41.687 27.689 56.552l-18.66 26.852h95.434c57.693 0 104.463-37.341 104.463-83.404s-46.77-83.404-104.463-83.404z",
    style: {},
    fill: "#ffffff",
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.001 228.703c-.136 0-.27.004-.406.004V395.51h.406c57.693 0 104.463-37.341 104.463-83.404 0-46.062-46.77-83.403-104.463-83.403z",
    style: {},
    fill: "#dce1eb",
    "data-original": "#dce1eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.801 110.517C371.783 110.516 435 160.989 435 223.25c0 29.499-14.197 56.347-37.426 76.439l25.222 36.295H293.801c-77.982 0-141.199-50.473-141.199-112.734 0-62.261 63.217-112.733 141.199-112.733z",
    style: {},
    fill: "#ffe70d",
    "data-original": "#ffda00",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.574 299.689C420.803 279.597 435 252.749 435 223.25c0-62.208-63.11-112.646-141-112.732v225.466h128.796l-25.222-36.295z",
    style: {},
    fill: "#fed402",
    "data-original": "#ffa426",
    className: "",
    opacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdPlanPerkChatIcon);
export default __webpack_public_path__ + "static/media/ad-plan-perk-chat-icon.8aac5a34e0b51199895b74e26789d9b3.svg";
export { ForwardRef as ReactComponent };